function numSecuToString(numSecu) {
    if (numSecu === null || numSecu === undefined) return ''

    const str =
        numSecu.sexeNS +
        numSecu.anneeNS +
        numSecu.moisNS +
        numSecu.deptNS +
        numSecu.cdeVilleNs +
        numSecu.numOrdreNS +
        numSecu.cleNS

    return str
}

function stringToNumSecu(str) {
    str = str.replace(/\s/g, '')

    const numSecu = {
        sexeNS: str.substring(0, 1),
        anneeNS: str.substring(1, 3),
        moisNS: str.substring(3, 5),
        deptNS: str.substring(5, 7),
        cdeVilleNs: str.substring(7, 10),
        numOrdreNS: str.substring(10, 13),
        cleNS: str.substring(13, 15)
    }

    return numSecu
}

export {
    numSecuToString,
    stringToNumSecu
}
